import { Attributes } from 'react';
import { useAfterAppLoaded } from 'src/hooks/useAfterAppLoaded';

export function withAfterAppLoaded<T extends Attributes>(AppComponent: React.ComponentType<T>) {
  return (props: T) => {
    useAfterAppLoaded();
    return <AppComponent {...props} />;
  };
}
